<!-- StartShoppingSection.vue -->
<template>
  <section class="section">
    <img src="./../assets/img/start.webp" alt="img start" class="img" />
    <div class="wrapper">
      <div class="right">
        <div class="title">
          {{ $t(`Start Your CS2 Journey`) }}
        </div>
        <div class="desc opacity-50">
          {{ $t(`Discover premium CS2 skins and stand out in every match.`) }}
        </div>
        <div class="buttons">
          <button class="button" @click="sellSkin">
            {{ $t(`Sell Skins`) }}
          </button>
          <router-link
            :to="{ name: 'ProductListPage', params: { itemType: 'all' } }"
            class="button red"
          >
            {{ $t(`Browse Skins`) }}
          </router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "StartShoppingSection",
  props: {
    isAuth: { type: Boolean },
  },
  methods: {
    sellSkin() {
      if (this.isAuth) {
        this.$emit("openSellSkinModal");
      } else {
        this.$emit("openSignIn");
      }
    },
  },
};
</script>

<style scoped>
.section {
  position: relative;
  padding: 0 16px;

  .img {
    position: absolute;
    height: 100%;
    width: auto;
    left: calc(50% - 400px);
    top: 0;
    transform: translateX(-50%);
  }
}

.section .wrapper {
  padding: 150px 0;
  position: relative;

  .right {
    margin: 0 0 0 auto;
    width: 50%;
  }
  .desc {
    margin: 30px 0;
  }
  .buttons {
    gap: 20px;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
}

@media (max-width: 768px) {
  .section {
    .img {
      display: none;
    }
    .wrapper {
      padding: 50px 0;
      .right {
        width: 100%;
      }
    }
  }
}
</style>
